import { cn } from "@lib/cn";
import { VERSIONS_TABLE_SESSIONS_SIZES } from "@pages/analytics/constants";

const BASE_CLASSNAME =
  "tw-px-2 tw-text-xs tw-font-sans tw-h-10 tw-text-blue-500 tw-font-medium tw-flex tw-items-center";
export const VersionsTableSessionsHeader = () => {
  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-bg-[#F9F9FA] tw-border-b tw-border-solid tw-border-blue-100 tw-sticky tw-top-0 tw-z-[2]">
      <div className={cn(BASE_CLASSNAME, "tw-flex-auto tw-pl-[52px] tw-pr-2")}>
        Reader
      </div>
      <div
        className={BASE_CLASSNAME}
        style={{ width: VERSIONS_TABLE_SESSIONS_SIZES.SESSION_STARTED }}
      >
        Session started
      </div>
      <div
        className={BASE_CLASSNAME}
        style={{ width: VERSIONS_TABLE_SESSIONS_SIZES.READING_TIME }}
      >
        Reading time
      </div>
      <div
        className={BASE_CLASSNAME}
        style={{ width: VERSIONS_TABLE_SESSIONS_SIZES.CLICKED_CTA }}
      >
        Clicked link
      </div>
      <div
        className={BASE_CLASSNAME}
        style={{ width: VERSIONS_TABLE_SESSIONS_SIZES.PROGRESS }}
      >
        Progress
      </div>
      <div
        className={BASE_CLASSNAME}
        style={{ width: VERSIONS_TABLE_SESSIONS_SIZES.LOCATION }}
      >
        Location
      </div>
      <div
        className={cn(BASE_CLASSNAME, "tw-pr-4")}
        style={{ width: VERSIONS_TABLE_SESSIONS_SIZES.DEVICE }}
      >
        Device
      </div>
    </div>
  );
};
